export interface Recommendation {
  id: string;
  author: string;
  role?: string;
  relation: string;
  date: string;
  text: string;
  linkedinUrl: string;
  photo?: string;
}

export const recommendations: Recommendation[] = [
  {
    id: 'alexis-gomes',
    author: 'Alexis Gomes',
    relation: 'Responsable direct',
    date: 'Avril 2025 - Mars 2026',
    text: 'Zoé est une lead et dev hors pair. Elle combine d\'excellentes compétences techniques avec un vrai sens du management. Toujours efficace et rassurante, c\'est un vrai pilier pour l\'équipe.',
    linkedinUrl: 'https://www.linkedin.com/in/alexis-gomes-9a357070/',
    photo: '/alexis.jpeg',
  },
  {
    id: 'kevin-bogaert',
    author: 'Kevin Bogaert',
    relation: 'Responsable direct',
    date: 'Septembre 2020 - Mars 2025',
    text: 'J\'ai eu la chance de travailler avec Zoé. Très agréable, efficace et possédant une grosse faculté d\'adaptation. Elle a pris en main des parties de codes techniques et anciennes pour les rendre plus adaptées en un rien de temps. Un vrai couteau suisse, elle a su manager son équipe dans des moments de stress et a su se montrer rassurante.',
    linkedinUrl: 'https://www.linkedin.com/in/kevin-bogaert-9a6ba1174/',
    photo: '/kevin.jpeg',
  },
];
